export default __webpack_public_path__ + "e6b92006f99f62d16791e8afd913062e.png";